var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Children } from 'react';
import { Box, Spacer } from '@telus-uds/components-web';
import _get from 'lodash/get';
import styled from 'styled-components';
import { fromLaptop } from '../../constants/breakpoints';
import zIndexes from '../../constants/zindexes';
import { PageSection } from '../PageSection/PageSection';
import { DevicePageTitle } from './DevicePageTitle/DevicePageTitle';
export var DeviceDetailsLayout = function (props) {
    var children = props.children;
    var childrenArray = Children.toArray(children);
    var pageTitle = childrenArray === null || childrenArray === void 0 ? void 0 : childrenArray.find(function (child) {
        var type = _get(child, 'type');
        return type === DevicePageTitle;
    });
    var filteredChildren = childrenArray === null || childrenArray === void 0 ? void 0 : childrenArray.filter(function (child) {
        var type = _get(child, 'type');
        return type !== DevicePageTitle;
    });
    return (_jsx(_Fragment, { children: (pageTitle !== null && pageTitle !== void 0 ? pageTitle : filteredChildren) && (_jsxs(Box, { variant: { background: 'lighter' }, children: [pageTitle && _jsx(StyledWrapper, { "data-testid": 'hero', children: pageTitle }), filteredChildren && _jsx(PageSection, { id: 'device-options', children: filteredChildren }), _jsx(Spacer, { space: { xs: 4, md: 8, lg: 7 } })] })) }));
};
// --------------------------- STYLES --------------------------- //
var StyledWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media ", " {\n    position: relative;\n    z-index: ", ";\n  }\n"], ["\n  @media ", " {\n    position: relative;\n    z-index: ", ";\n  }\n"])), fromLaptop, zIndexes.background);
export default DeviceDetailsLayout;
var templateObject_1;
